import { Destructable, DestructionObserver, Subscription } from "./types";

export default class DestructableObject implements Destructable {
	private __private__parent?: Destructable;
	private _children?: Set<Destructable>;
	private _destruction_observers?: Set<DestructionObserver>;
	private _destroyed = false;

	destroy(): void {
		if (this._destroyed) return;
		this._destroyed = true;
		if (this.__private__parent) {
			(this.__private__parent as DestructableObject)._children?.delete(this);
		}
		if (this._children) {
			for (const child of this._children) {
				child.destroy();
			}
		}
		if (this._destruction_observers) {
			for (const observer of this._destruction_observers) {
				observer();
			}
			this._destruction_observers.clear();
		}
	}

	get destroyed(): boolean {
		return this._destroyed;
	}

	addChild(child: Destructable) {
		if (this.destroyed) {
			child.destroy();
		} else {
			(this._children ??= new Set<Destructable>()).add(child);
			(child as any).__private__parent = this;
		}
		return child;
	}

	onDestroy(observer: DestructionObserver): Subscription {
		if (this.destroyed) {
			observer();
		} else {
			(this._destruction_observers ??= new Set()).add(observer);
		}
		return {
			unsubscribe: () => this._destruction_observers!.delete(observer),
		};
	}
}
